import { useContext, useEffect, useState } from 'react';
import { CustomerIdAndOrderIdIntegrityValidator } from './validator/CustomerIdAndOrderIdIntegrityValidator';
import { CustomerIdAndOrderIdIntegrityResponse } from '../../services/connectors/CustomerIdAndOrderIdIntegrityResponse';
import { FormFields } from '../../components/form/fields/FormFields';
import { OrderCompositeField } from './types';
import { AppShopContext } from '../../components/context/AppShopContext';
import { KeycloakContext } from '../../components/context/KeycloakContext';

export function useCustomerIdAndOrderIdIntegrity(
  formFieldValidations: any,
  customerId: string,
  orderId: OrderCompositeField,
) {
  const appContext = useContext(AppShopContext);
  const keycloakContext = useContext(KeycloakContext);
  const isUserLoggedIn = !!keycloakContext.tokenData?.customerId;
  const [isValidatingCustomerIdAndOrderIdIntegrity, setIsValidatingCustomerIdAndOrderIdIntegrity] =
    useState(false);
  const [customerIdAndOrderIdIntegrityValidator, setCustomerIdAndOrderIdIntegrityValidator] =
    useState<CustomerIdAndOrderIdIntegrityValidator>();
  useEffect(() => {
    setCustomerIdAndOrderIdIntegrityValidator(
      new CustomerIdAndOrderIdIntegrityValidator(
        customerId,
        orderId,
        () => setIsValidatingCustomerIdAndOrderIdIntegrity(true),
        () => setIsValidatingCustomerIdAndOrderIdIntegrity(false),
        (validationServiceResponse: CustomerIdAndOrderIdIntegrityResponse) => {
          if (!validationServiceResponse.isOrderIdValid) {
            return;
          }
          let isValid = validationServiceResponse.customerIdAndOrderIdMatch;
          const fieldValidation = formFieldValidations[FormFields.orderNumber];
          fieldValidation.setValidationState(isValid, !isValid, [
            'customer_id_and_order_id_do_not_match',
          ]);
        },
        isUserLoggedIn,
      ),
    );
  }, [customerId, orderId, formFieldValidations, appContext.siteId]);

  return {
    orderNumberValidator: customerIdAndOrderIdIntegrityValidator,
    isProcessingCustomerNumber: isValidatingCustomerIdAndOrderIdIntegrity,
    isProcessingOrderNumber: isValidatingCustomerIdAndOrderIdIntegrity,
  };
}
